import { render, staticRenderFns } from "./imageviewer.vue.html?vue&type=template&id=f5ab710a"
import script from "./imageviewer.controller?vue&type=script&lang=js&external"
export * from "./imageviewer.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports